module.exports = __webpack_public_path__ + "static/media/Access to ambulance.4d1a9002.png";